<template>
  <div style="width:100%">
    <v-subheader v-if="!mbglSupported">
      Votre navigateur n'est pas compatible avec cette application.
      Une version de cette application compatible avec un plus grand nombre de navigateurs sera bientôt publiée.
    </v-subheader>
    <template v-else>
      <template v-if="windowWidth < 960">
        <mbgl-map
          :style="`height:${windowHeight- 56}px`"
        />
        <navigation-bottom />
      </template>
      <v-row
        v-else
        class="px-3"
      >
        <v-col
          class="px-0"
          :cols="8"
          :lg="9"
          :xl="10"
        >
          <mbgl-map />
        </v-col>
        <v-col
          class="px-0"
          :cols="4"
          :lg="3"
          :xl="2"
          :style="`max-height:${windowHeight}px;overflow-y:auto`"
        >
          <navigation-right />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import MbglMap from './MbglMap.vue'
import NavigationRight from './navigation-right.vue'
import NavigationBottom from './navigation-bottom.vue'
const mbglSupported = require('@mapbox/mapbox-gl-supported')()

export default {
  name: 'Home',
  components: { MbglMap, NavigationRight, NavigationBottom },
  data () {
    return {
      mbglSupported
    }
  }
}
</script>

<style></style>
